import { NavLink, Outlet } from 'react-router-dom';
import { Activity, Inbox, Monitor, Settings } from 'lucide-react';
import { cn } from '../lib/cn.js';

const tabs = [
  { to: '/machines', icon: Monitor, label: 'Machines' },
  { to: '/active', icon: Activity, label: 'Активные' },
  { to: '/inbox', icon: Inbox, label: 'Inbox' },
  { to: '/settings', icon: Settings, label: 'Settings' },
] as const;

export function Layout() {
  return (
    <div className="safe-top min-h-dvh flex flex-col bg-neutral-950 text-neutral-100">
      <main className="flex-1 pb-[calc(4rem+env(safe-area-inset-bottom))] overflow-y-auto">
        <Outlet />
      </main>
      <nav
        className="fixed bottom-0 left-0 right-0 border-t border-neutral-800 bg-neutral-950/95 backdrop-blur"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <ul className="flex h-16">
          {tabs.map(({ to, icon: Icon, label }) => (
            <li key={to} className="flex-1">
              <NavLink
                to={to}
                className={({ isActive }) =>
                  cn(
                    'h-full flex flex-col items-center justify-center gap-1 text-[11px]',
                    isActive ? 'text-blue-400' : 'text-neutral-500',
                  )
                }
              >
                <Icon className="w-6 h-6" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
